import React from 'react';
import styled from 'styled-components';

const Error = () => {
    return (
        <ErrorWithStyled className="text-center">
            データが取得できませんでした
        </ErrorWithStyled>
    );
};

const ErrorWithStyled = styled.div`
`

export default Error;